var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2ImplementAProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 11H46a6 6 0 00-6 6v13a6 6 0 006 6h13a6 6 0 006-6V17a6 6 0 00-6-6zm2 19a2 2 0 01-2 2H46a2 2 0 01-2-2V17a2 2 0 012-2h13a2 2 0 012 2v13zM41.5 61h22v4h-22v-4zm13-20v11h5l-7 7-7-7h5V41h4zM30 40H17a6 6 0 00-6 6v13a6 6 0 006 6h13a6 6 0 006-6V46a6 6 0 00-6-6zm2 19a2 2 0 01-2 2H17a2 2 0 01-2-2V46a2 2 0 012-2h13a2 2 0 012 2v13zm-2-48H17a6 6 0 00-6 6v13a6 6 0 006 6h13a6 6 0 006-6V17a6 6 0 00-6-6zm2 19a2 2 0 01-2 2H17a2 2 0 01-2-2V17a2 2 0 012-2h13a2 2 0 012 2v13z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Implement_a_product.315e9a7d.svg";
export { SvgJ2ImplementAProduct as ReactComponent };